var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPaypal = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon--paypal",
  viewBox: "0 0 1000 1000",
  width: 24,
  height: 24,
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M918 239.3c-9.2-11.4-20-21.8-31.9-31.1 1.6 29.5-1.1 61-8.3 94.2-19.4 90.9-65.8 168.2-134.2 223.5-68.4 55.2-153.7 84.4-246.8 84.4H361l-44 205.9c-8.6 40.4-44.9 69.7-86.2 69.7h-61.2l-11 50.6c-2.8 13 .4 26.6 8.7 37 8.4 10.4 21 16.4 34.3 16.4h149.6c20.8 0 38.8-14.5 43.1-34.9l51.4-240.8h171.4c82.9 0 158.7-25.8 219.1-74.6 60.5-48.8 101.6-117.4 118.8-198.4 17.7-81.7 5.2-149.7-37-201.9z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M273.9 807l51.4-240.8h171.4c82.9 0 158.7-25.8 219.1-74.6 60.5-48.8 101.6-117.4 118.8-198.4 17.5-81.9 5-149.8-37.2-202C757 41.1 687.7 10 616.7 10H243.2c-20.7 0-38.6 14.4-43.1 34.7l-162 743.8c-2.8 13 .4 26.6 8.7 37 8.4 10.4 21 16.4 34.3 16.4h149.6c20.9 0 38.9-14.5 43.2-34.9zm137.2-627.6h117.5c27.7 0 52.4 11.6 67.8 31.8 16.4 21.5 21.2 51.1 13.2 81.4l-.3 1.2C594.5 356.2 533 407 472.3 407H359.7l51.4-227.6z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPaypal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconPaypal.f2aeb250.svg";
export { ForwardRef as ReactComponent };